<template>
    <div class="el-table-container templateBox">
        <!--个人中心-->
        <el-form size="small" class="content" ref="personalForm" :model="personalForm" :rules="rules"
                 label-position="top">
            <div class="minTitle">基本设置</div>
            <div class="flex_b_t">
                <div class="substance">
<!--                    <el-form-item label="登陆名" prop="loginName">-->
<!--                        <el-input v-model.trim="personalForm.loginName" maxlength="20"-->
<!--                                  placeholder="请输入登陆名(限20字)"-->
<!--                                  clearable></el-input>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item label="登陆密码" prop="password"-->
<!--                                  :rules="[{required: true, message: '请输入登陆密码', trigger: 'blur'},{validator:validator.isPwd, trigger:'blur'}]">-->
<!--                        <el-input show-password v-model="personalForm.password"-->
<!--                                  placeholder="请输入密码（8-20位包含大小写字母，数字，特殊符号例如@）"-->
<!--                                  maxlength="20"-->
<!--                                  auto-complete="new-password"></el-input>-->
<!--                    </el-form-item>-->
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model="personalForm.name" placeholder="请输入姓名(限20字)" maxlength="20"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="性别" prop="sex">
                        <el-radio-group v-model="personalForm.sex">
                            <el-radio label="2">保密</el-radio>
                            <el-radio label="0">男</el-radio>
                            <el-radio label="1">女</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="手机号" prop="mobilePhone"
                                  :rules="[{required: true, message: '请输入手机号', trigger: 'blur'},{validator:validator.isMobile, trigger:'blur'}]">
                        <el-input v-model="personalForm.mobilePhone" placeholder="请输入手机号"
                                  maxlength="11" @input="setBorrowDays('mobilePhone')"
                                  auto-complete="new-password"></el-input>
                    </el-form-item>
                    <el-form-item label="电话">
<!--                        <div class="flex_l_c">-->
<!--                            <el-form-item label-width="0" prop="areaCode" style="width: 150px;margin-right: 10px">-->
<!--                                <el-input v-model.trim="personalForm.areaCode" placeholder="请输入区号"-->
<!--                                          maxlength="4" @input="setBorrowDays('areaCode')"-->
<!--                                          auto-complete="new-password"></el-input>-->
<!--                            </el-form-item>-->
                            <el-form-item label-width="0" prop="telPhone" style="width: 100%;">
                                <el-input v-model.trim="personalForm.telPhone" placeholder="请输入电话号码"
                                          auto-complete="new-password"></el-input>
                            </el-form-item>
<!--                        </div>-->
                    </el-form-item>
                    <el-form-item label="邮箱" prop="email" :rules="[{validator:validator.isEmail, trigger:'blur'}]">
                        <el-input v-model.trim="personalForm.email" placeholder="邮箱（xxxxxxx@xxx.xxx）" maxlength="30"
                                  auto-complete="new-password"></el-input>
                    </el-form-item>
                    <div class="magBtn">所在部门 <span style="margin-left: 15px">{{ personalForm.departmentName }}</span></div>
                    <div class="magBtn">所属角色 <span style="margin-left: 15px">{{ personalForm.roleNames }}</span></div>
                    <el-button size="small" type="primary" @click="updateInfor()">更新信息</el-button>
                </div>
                <div class="substance text_center">
                    <el-link class="secretCode" type="primary" :underline="false" @click="setPassword()">修改密码</el-link>
                    <el-image
                        class="profilePicture"
                        :src="personalForm.image"
                        :preview-src-list="[personalForm.image]"
                        fit="fill"></el-image>
                    <HeadUpload :image="personalForm.image" @getImgList="getImgList"/>
                </div>
            </div>
        </el-form>
        <set-password ref="setPassword" @refresh="getDetails()"></set-password>
    </div>
</template>

<script>
import HeadUpload from "@/components/headUpload/index.vue";
import SetPassword from "@/views/modules/sys/personal/setPassword.vue";

export default {
    name: "myInfo",
    components: {SetPassword, HeadUpload},
    data() {
        var checkAreaCode = (rule, value, callback) => {
            if (value !== '') {
                if (!/^\d{3,4}$/.test(value)) {
                    callback(new Error('请输入正确的区号!'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        var checkPhoneNumber = (rule, value, callback) => {
            if (value !== '') {
                if (!/^0\d{2,3}-?\d{7,8}$/.test(value)) {
                    callback(new Error('请输入正确的电话号码!'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        return {
            personalForm: {
                id:'',
                loginName: '',
                password: '',
                name: '',
                sex: 0,
                mobilePhone: '',
                areaCode: '',
                telPhone:'',
                email:'',
                image:'',
                departmentName:'',
                roleNames:'',
            },
            rules: {
                loginName: [
                    {required: true, message: '请输入登陆名', trigger: 'blur'},
                ],
                name: [
                    {required: true, message: '请输入姓名', trigger: 'blur'},
                ],
                areaCode: [
                    {validator: checkAreaCode, message: '请输入正确的区号', trigger: 'blur'},
                ],
                telPhone: [
                    {validator: checkPhoneNumber, message: '请输入正确的电话号码', trigger: 'blur'},
                ],
            },
        }
    },

    mounted() {
        this.getDetails()
    },

    methods:{
        //获取我的详情
        getDetails(){
            let userInfo = this.$store.state.user.userInfo;
            this.$axios(this.api.user.getUserRoleInfo + '/' + userInfo.id, {}).then(data => {
                if (data.status) {
                    this.$store.commit('user/updateUser', data.data)
                    this.recover(this.personalForm, data.data);
                } else {
                    this.$message.error('查询失败');
                }
            })
        },

        //只能输入大于等于0的正整数
        setBorrowDays(formName) {
            this.personalForm[formName] = this.personalForm[formName].replace(/[^0-9]/g, "")
        },

        // 获取用户头像
        getImgList(data) {
            this.personalForm.image = data
            this.$axios(this.api.user.sysuserUpdateById, {
                id:this.personalForm.id,
                image:this.personalForm.image,
                type: 3,
            }, 'post').then(data => {
                if (data && data.status) {
                    this.$message.success('更换成功')
                    this.getDetails()
                } else {
                    this.$message.error(data.msg)
                }
            })
        },

        //修改密码
        setPassword(){
            this.$refs.setPassword.init()
        },

        //更新信息
        updateInfor(){
            this.$refs.personalForm.validate((valid) => {
                if (valid) {
                    this.$axios(this.api.user.sysuserUpdateById, {
                        ...this.personalForm,
                        type: 3,
                    }, 'post').then(data => {
                        if (data && data.status) {
                            this.$message.success('修改成功')
                            this.getDetails()
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }
            })
        },
    },
}
</script>

<style scoped>
.templateBox{
    overflow-y: auto;
}

.content {
    padding: 20px 100px 20px;
}

.minTitle {
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 10px;
}

.substance {
    position: relative;
    width: 45%;
}

.secretCode{
    position: absolute;
    top: 270px;
    left: 0;
    right: 0;
    text-align: center;
}

.magBtn{
    margin-bottom: 15px;
}

.profilePicture{
    margin-top: 50px;
    margin-bottom: 20px;
    width: 150px;
    height: 150px;
    border-radius: 50%;
}
</style>